import expireCreditAppDeals from './expireCreditAppDeals.js';
import expireCreditVerification from './expireCreditVerification.js';
import buildDefaultPaymentsInfo from './buildDefaultPaymentsInfo.js';
function validatePaymentsInfo(paymentsInfo, myWalletConfigs, customWalletDefaults) {
  const _paymentsInfo = {
    ...paymentsInfo
  };

  // if payment info is present but some of the required values are null, set them to default values
  const {
    creditType,
    downPayment,
    downPaymentPercent,
    loanTerm,
    interestRate = {}
  } = _paymentsInfo;
  const hasRequiredValues = creditType == null || loanTerm == null || downPayment == null && downPaymentPercent == null;
  const hasInterestRates = Object.keys(interestRate).length === 0;
  const defaultPaymentsInfo = buildDefaultPaymentsInfo(myWalletConfigs, customWalletDefaults);
  if (hasRequiredValues || hasInterestRates) {
    Object.keys(_paymentsInfo).forEach(key => {
      if (_paymentsInfo[key] == null || Object.keys(_paymentsInfo[key]).length === 0) {
        // Set default value if missing
        _paymentsInfo[key] = defaultPaymentsInfo[key];
      }
    });
  }
  if (!_paymentsInfo.createdDate) {
    _paymentsInfo.createdDate = _paymentsInfo.timeStamp ?? Date.now();
  }
  expireCreditAppDeals(_paymentsInfo);
  expireCreditVerification(_paymentsInfo);
  return _paymentsInfo;
}
export { validatePaymentsInfo as default };
